import Image from 'next/image';
import React from 'react';
import useScreenSize from '../../../hooks/useScreenSize';

export const TurboLogo: React.FC = () => {
  const { isLarge } = useScreenSize();

  return isLarge ? (
    <Image
      data-cy="turbo-screenshot"
      width={112}
      height={115}
      src="/static/images/turbo_screen.png"
      alt=""
    />
  ) : (
    <Image
      width={45}
      height={45}
      src="/static/images/turbo_app_logo.png"
      data-cy="turbo-logo"
      alt=""
    />
  );
};
